import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './style.scss';
class Heading extends Component {
  constructor(){
    super()
    this.state = {}
  }

  render(){
    // console.log(`HEADING\npassed data\n$::`, this.props)
    const { data } = this.props
    let content
    switch(parseInt(data.lxl_heading_level)){
      case 1:
        content = <h1 className="heading heading-1">{ ReactHtmlParser(data.lxl_heading) }</h1>
      break
      case 2:
        content = <h2 className="heading heading-2">{ ReactHtmlParser(data.lxl_heading) }</h2>
      break
      case 3:
        content = <h3 className="heading heading-3">{ ReactHtmlParser(data.lxl_heading) }</h3>
      break
      case 4:
        content = <h4 className="heading heading-4">{ ReactHtmlParser(data.lxl_heading) }</h4>
      break
      case 5:
        content = <h5 className="heading heading-5">{ ReactHtmlParser(data.lxl_heading) }</h5>
      break
      case 6:
        content = <h6 className="heading heading-6">{ ReactHtmlParser(data.lxl_heading) }</h6>
      break
      default:
        content = <h2 className="heading heading-2">{ ReactHtmlParser(data.lxl_heading) }</h2>
    }
    return content
  }
}

export default Heading
